'use client';

import { useEffect, useState } from 'react';

export const CountdownTimer = ({
  date,
  renderDays,
  renderSeconds,
}: {
  date: Date;
  renderDays?: boolean;
  renderSeconds?: boolean;
}) => {
  const [days, setDays] = useState(10);
  const [hours, setHours] = useState(10);
  const [minutes, setMinutes] = useState(10);
  const [seconds, setSeconds] = useState(10);

  useEffect(() => {
    const countdown = () => {
      const endDate = new Date(date).getTime();
      const today = new Date().getTime();

      const timeDiff = endDate - today;

      const seconds = 1000;
      const minutes = seconds * 60;
      const hours = minutes * 60;
      const days = hours * 24;

      const timeDays = Math.floor(timeDiff / days);
      let timeHours = Math.floor((timeDiff % days) / hours);
      let timeMinutes = Math.floor((timeDiff % hours) / minutes);
      let timeSeconds = Math.floor((timeDiff % minutes) / seconds);

      timeHours = timeHours < 10 ? 0 + timeHours : timeHours;
      timeMinutes = Number(timeMinutes < 10 ? '0' + timeMinutes : timeMinutes);
      timeSeconds = Number(timeSeconds < 10 ? '0' + timeSeconds : timeSeconds);

      setDays(timeDays);
      setHours(timeHours);
      setMinutes(timeMinutes);
      setSeconds(timeSeconds);
    };

    const id = setInterval(countdown, 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <span className="CountdownTimer">
      {renderDays && days !== 0 ? <>{days}d</> : null} {hours}h {minutes}m{' '}
      {renderSeconds === true ? <>{seconds}s</> : null}
    </span>
  );
};
